/* istanbul ignore file */

// declarative file
export enum FormName {
  CONTACT = 'formulaire de contact FAQ',
  FRAUD = 'formulaire de contact usurpation d’identité',
  REACTIVATION = 'formulaire de réactivation',
  SECURITY = 'formulaire de sécurité FAQ',
  STANDARD = 'formulaire de contact standard',
  TECHNICAL = 'formulaire technique',
}
